import SimpleBar from 'simplebar-react';
import styled, { css } from 'styled-components';

import { Config as ScrollbarConfig } from '../../theme/Scrollbar';
import { rem } from '../../utils';

const TRANSITION_DELAY = 2000;

export const StyledScrollArea = styled(SimpleBar)(
  ({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .simplebar-wrapper,
    .simplebar-content-wrapper,
    .simplebar-mask,
    .simplebar-offset {
      height: 100%;
    }

    .simplebar-content-wrapper {
      box-sizing: border-box;
      scrollbar-gutter: stable both-edges;
      scrollbar-width: none;
      scrollbar-color: ${theme.Color.Neutrals.Border} transparent;
    }

    .simplebar-content {
      display: flex;
      flex-direction: column;
    }

    &[data-direction='horizontal'] {
      .simplebar-content {
        flex-direction: row;
      }

      .simplebar-wrapper,
      .simplebar-content-wrapper,
      .simplebar-mask,
      .simplebar-offset {
        height: auto;
        width: 100%;
      }
    }

    &[data-direction='both'] {
      .simplebar-content {
        flex-direction: row;
        flex-wrap: wrap;
      }
    }

    .simplebar-track {
      background-color: transparent;
      border-radius: ${rem(ScrollbarConfig.NormalWidth)};
    }

    .simplebar-track.simplebar-vertical {
      width: ${rem(ScrollbarConfig.NormalWidth)} !important;
      right: ${rem(ScrollbarConfig.ThinWidth)};
    }

    .simplebar-track.simplebar-horizontal {
      height: ${rem(ScrollbarConfig.NormalWidth)};
      bottom: ${rem(ScrollbarConfig.ThinWidth)};
      left: 0;
    }

    .simplebar-track {
      cursor: pointer;
      pointer-events: all !important;
    }

    /* Override SimpleBar default styles with higher specificity */
    &.simplebar-scrollable-y .simplebar-scrollbar:before,
    &.simplebar-scrollable-x .simplebar-scrollbar:before {
      background: ${theme.Color.Neutrals.Dark} !important;
      border-radius: ${rem(ScrollbarConfig.ThinWidth)} !important;
      opacity: 0.1 !important;
      transition: opacity ${theme.Transition.Timing.In},
        background-color ${theme.Transition.Timing.In} !important;
      top: 0 !important;
      right: 0 !important;
      left: 0 !important;
      bottom: 0 !important;
      transition-delay: ${TRANSITION_DELAY}ms !important;
      cursor: pointer !important;
      pointer-events: all !important;
    }

    &.simplebar-scrollable-y .simplebar-scrollbar:hover:before,
    &.simplebar-scrollable-x .simplebar-scrollbar:hover:before,
    &.simplebar-scrollable-y .simplebar-scrollbar.simplebar-visible:before,
    &.simplebar-scrollable-x .simplebar-scrollbar.simplebar-visible:before {
      background: ${theme.Color.Neutrals.Dark} !important;
      opacity: 0.2 !important;
      cursor: pointer !important;
      transition: opacity ${theme.Transition.Timing.In},
        background-color ${theme.Transition.Timing.In} !important;
    }

    &.simplebar-scrollable-y .simplebar-scrollbar,
    &.simplebar-scrollable-x .simplebar-scrollbar {
      cursor: pointer !important;
    }

    .simplebar-placeholder {
      display: none;
    }
  `
);
